import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Box,
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Icon,
  Button,
} from '@material-ui/core';

import Actions from '../../../../store/ducks/appointments';
import useStyles from './styles';
import Loading from './Loading';

const ProfessionalModal = ({ handleExited, professionalId }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { list: professionals } = useSelector(
    state => state.appointments.professionals,
  );
  const [open, setOpen] = useState(true);
  const [professionalRequested, setProfessionalRequested] = useState(null);
  const [professionalInfos, setProfessionalInfos] = useState({});
  const [loading, setLoading] = useState(true);

  const requestProfessional = useCallback(
    id => {
      dispatch(Actions.requestProfessional(id));
      setProfessionalRequested(id);
    },
    [dispatch],
  );

  useEffect(() => {
    if (!professionalId) return;
    if (professionalId in professionals) {
      setProfessionalInfos(professionals[professionalId]);
    } else if (professionalRequested !== professionalId) {
      requestProfessional(professionalId);
    }
  }, [
    professionalId,
    professionals,
    professionalRequested,
    requestProfessional,
  ]);

  useEffect(() => {
    if (professionalInfos.allLoaded) {
      setLoading(false);
    }
  }, [professionalId, professionalInfos]);

  const handleCloseModal = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <Dialog
      className={classes.container}
      classes={{ paper: classes.paper }}
      onClose={handleCloseModal}
      onExited={handleExited}
      open={open}
      maxWidth="xs"
    >
      <DialogContent>
        {loading ? (
          <Loading />
        ) : (
          <Box className="professional-content">
            <Icon className="professional-icon" fontSize="inherit">
              perm_contact_calendar
            </Icon>
            <Box className="professional-infos-container">
              <Box className="professional-infos-box name">
                <Typography
                  variant="caption"
                  className="professional-infos-label"
                >
                  Profissional:
                </Typography>
                <Typography
                  variant="subtitle1"
                  className="professional-infos-value"
                >
                  {professionalInfos.name}
                </Typography>
              </Box>
              <Box className="professional-infos-box contact">
                <Typography
                  variant="caption"
                  className="professional-infos-label"
                >
                  Contato:
                </Typography>
                <Typography
                  variant="body2"
                  className="professional-infos-value"
                >
                  {professionalInfos.contact}
                </Typography>
              </Box>
              <Box className="professional-infos-box description">
                <Typography
                  variant="caption"
                  className="professional-infos-label"
                >
                  Descrição:
                </Typography>
                <Typography
                  variant="body2"
                  className="professional-infos-value"
                >
                  {professionalInfos.describe}
                </Typography>
              </Box>
            </Box>
          </Box>
        )}
      </DialogContent>
      {!loading && (
        <DialogActions>
          <Button onClick={handleCloseModal}>Fechar</Button>
        </DialogActions>
      )}
    </Dialog>
  );
};

export default ProfessionalModal;
